<template>
  <transition
    name="dialog-fade"
    @after-enter="afterEnter"
    @after-leave="afterLeave">
    <div
      v-show="visible"
      :class="['bcc-dialog__wrap', { 'bcc-dialog__wrap-mask': mask }]"
      @click="maskHandle">
      <div
        :class="['bcc-dialog', customClass]"
        :style='style'>
        <div class="bcc-dialog__header">
          <slot name="title">
            <span class="bcc-dialog__title">{{ title }}</span>
          </slot>
          <bcc-icon
            v-if="showClose"
            @click="close"
            class="bcc-dialog__close"
            type="ic_delete_" />
        </div>
        <div class="bcc-dialog__body">
          <slot></slot>
        </div>
        <div class="bcc-dialog__footer">
          <slot name="footer">
            <bcc-button type='primary' size='large' @click="ok">确定</bcc-button>
            <bcc-button size='large' @click="close">取消</bcc-button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BccButton from '../button'
import BccIcon from '../icon'

export default {
  name: 'BccDialog',
  components: {
    BccButton,
    BccIcon
  },
  data () {
    return {
      overflowInit: ''
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '50%'
    },
    top: {
      type: String,
      default: '30vh'
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    },
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    style () {
      return {
        width: this.width,
        top: this.top
      }
    }
  },
  watch: {
    visible (val) {
      this.visibleHandle(val)
    }
  },
  mounted () {
    this.overflowInit = document.body.style.overflow || ''
    this.visible && this.visibleHandle(this.visible)
  },
  methods: {
    visibleHandle (val) {
      val && this.$emit('open')
      this.lockScroll && this.lockScrollHandle(val)
    },
    lockScrollHandle (val) {
      const body = document.body
      if (val) {
        body.style.overflow = 'hidden'
      } else {
        body.style.overflow = this.overflowInit
      }
    },
    close () {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    ok () {
      this.$emit('ok')
    },
    maskHandle () {
      if (this.mask && this.maskClosable) {
        this.close()
      }
    },
    afterEnter () {
      this.$emit('opened')
    },
    afterLeave () {
      this.$emit('closed')
    }
  },
  destroyed () {
    this.lockScroll && this.lockScrollHandle(false)
  }
}
</script>
